var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="Вы использует браузер Internet Explorer 9. Наш сайт его не поддерживает, пожайлуста зайдите используя другой браузер.";
ngModule.run(["$templateCache",function(c){c.put("wrongBrowser/templates/index.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/wrongBrowser/templates/index.html
 ** module id = 610
 ** module chunks = 1
 **/